import Layout from "@/layout/index.vue";
const appUserManager = {
    path: '/appUser',
    component: Layout,
    redirect: 'noRedirect',
    name: 'appUser',
    meta: {
        title: '',
        icon: 'DocumentCopy'
    },
    children: [
        {
            path: 'ulist',
            component: () => import('@/views/appuser/index.vue'),
            name: 'ulist',
            meta: { title: '用户列表', noCache: true,icon: 'DocumentCopy'  }
        },
    ]

}

export default appUserManager
